import Axios from '../../../utils/union-axios'

/**
 * 根据uid查询用户充电省钱团成员身份
 */
export function GetUserMembership(data) {
  return Axios.get(`/web-h5/charge/member/getUserMembership`, data)
}

/**
 * 获取小鹏车主终身享省钱团特权说明
 */
export function GetXpOwnerPrivilege(data) {
  return Axios.get(`/web-h5/charge/member/getXpOwnerPrivilege`, data)
}

/**
 * 查看券包商品列表
 */
export function GetCouponPackGoods(data) {
  return Axios.get(`/web-h5/charge/member/queryCouponPackGoods`, data)
}

/**
 * 查看省钱卡商品列表
 */
export function GetMemberCardGoods(data) {
  return Axios.get(`/web-h5/charge/member/queryMemberCardGoods`, data)
}

/**
 * 查看省钱团商品列表
 */
export function GetMemberGoods() {
  return Axios.get(`/web-h5/charge/member/indexMemberGoods`)
}

/**
 * 用户券包获取记录
 */
export function PostUserCouponPackRecords(data) {
  return Axios.post(`/web-h5/charge/member/queryUserCouponPackRecords`, data)
}

/**
 * 用户省钱卡获取记录
 */
export function PostUserMemberCardRecords(data) {
  return Axios.post(`/web-h5/charge/member/queryUserMemberCardRecords`, data)
}

/**
 * 预购买省钱团商品
 */
export function PostPreBuyMemberGoods(data) {
  return Axios.post(`/web-h5/charge/member/preBuyMemberGoods`, data)
}

/**
 * 查询VIP站点列表
 */
export function GetQueryStationList(data) {
  return Axios.post(`/web-h5/charge/member/queryStationList`, data)
}

/**
 * 查询VIP卡券获得记录
 */
export function GetQueryMyGoodsRecord(data) {
  return Axios.post(`/web-h5/charge/member/queryMyGoodsRecord`, data)
}


/**
 * 查看省钱团商品列表(新接口)
 */
export function GetMyMemberGoods() {
  return Axios.get(`/web-h5/charge/member/queryMyMemberGoods`)
}


/**
 * 查看红包列表
 */
export function queryDiscountCouponPage(data) {
  return Axios.post(`/web-h5/charge/member/queryDiscountCouponPage`, data)
}

/**
 * 获取用户信息
 */
export function getCurrentUserInfo() {
  return Axios.get(`/web-h5/charge/member/getCurrentUserInfo`)
}

/**
 * 点击领券
 */
export function getDiscountCoupon(data) {
  return Axios.post(`/web-h5/charge/member/getDiscountCouponByUser`, data)
}